import styled from 'styled-components';

import { device } from 'common/constants/mediaQueries';

export const Container = styled.div``;

export const Div = styled.div``;

export const Form = styled.form`
  width: 100%;
`;

export const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--s4);
`;

/*
 * The EN/AR pair. Was a centred flex row, so the two fields drifted out of
 * line as soon as one of them carried a message. The `input[name='ar-title']`
 * rule is gone — the control takes `dir="rtl"`, which also gives it --font-ar.
 */
export const FormBoxes = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: start;
  gap: var(--s4);

  @media ${device.laptop} {
    grid-template-columns: 1fr;
  }
`;

export const Check = styled.div`
  display: flex;
  align-items: center;
`;

/** The design's `.actionbar`, on the card's foot. */
export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--s2);
  margin: var(--s5) calc(var(--s5) * -1) calc(var(--s5) * -1);
  padding: var(--s4) var(--s5);
  border-top: 1px solid var(--line);
  background: var(--surface-alt);
`;
